"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areDimValuesTrusted = exports.isDimValueValid = exports.areDimValuesPopulated = exports.areDimensionsValid = exports.trustedDimSourceTypes = exports.dimSourceTypeRanking = void 0;
exports.dimSourceTypeRanking = [
    "listingtool",
    "amazoncostcalc",
    "seller",
    "warehouse",
    "amazonscraped",
    "crossdock",
    "fc-dims-and-weight",
    "averageregression",
    "manual",
];
exports.trustedDimSourceTypes = [
    "amazonscraped",
    "averageregression",
    "crossdock",
    "fc-dims-and-weight",
    "manual",
    "warehouse",
    "seller",
];
const areDimensionsValid = (productDimensions) => {
    return (0, exports.areDimValuesPopulated)(productDimensions) && (0, exports.areDimValuesTrusted)(productDimensions);
};
exports.areDimensionsValid = areDimensionsValid;
const areDimValuesPopulated = (productDimensions) => {
    return [productDimensions.length, productDimensions.width, productDimensions.height, productDimensions.weight].every(exports.isDimValueValid);
};
exports.areDimValuesPopulated = areDimValuesPopulated;
const isDimValueValid = (value) => {
    return Boolean(value && value >= 0.001);
};
exports.isDimValueValid = isDimValueValid;
const areDimValuesTrusted = (productDimensions) => {
    return !productDimensions.dimSourceType
        ? false
        : exports.trustedDimSourceTypes.includes(productDimensions.dimSourceType);
};
exports.areDimValuesTrusted = areDimValuesTrusted;
//# sourceMappingURL=ProductDimensionUtils.js.map